const isUserUploadedURL = url => url.indexOf('uploads.sayi.do') > -1;

const isAssetsURL = url =>
  url.indexOf('https://storage.googleapis.com/sayido-assets-production/') > -1;

export const generateImageFromCDN = (image, options = {}) => {
  const defaultOptions = {
    width: 800,
    height: 600,
    fit: 'crop',
    // facepad: '2.5',
  };
  if (!image) {
    return false;
  }
  const url = image.original || image;
  const o = Object.assign({}, defaultOptions, options);
  const IMGOPTIM_OPTIONS = `${o.width}x${o.height},${o.fit},quality=high`;
  if (isUserUploadedURL(url)) {
    // BUNNY CDN
    const cdnRoot = 'https://bcdn-2738.sayido.app/';
    const path = url.split('uploads.sayi.do')[1];
    const queryStr = Object.keys(o)
      .map(k => `${k}=${o[k]}`)
      .join('&');
    return `${cdnRoot}${path}?${queryStr}`;
  } else if (isAssetsURL(url)) {
    const CDN_URL = 'https://sayido-assets-production.b-cdn.net/';
    return `${url.replace(
      'https://storage.googleapis.com/sayido-assets-production/',
      CDN_URL
    )}&height=auto&width=${options.width}&aspect_ratio=auto&quality=90`;
  } else if (url.indexOf('amazonaws.com') > -1) {
    const cdnRoot = 'https://sayido-legacy.b-cdn.net/';
    const path = url.split('amazonaws.com/')[1];
    const queryStr = `width=${o.width}&height=${o.height}`;
    return `${cdnRoot}${path}?${queryStr}`;
    // } else if (url.indexOf('amazonaws.com') > -1) {
    // Image is using legacy AWS storage, so use imageoptim (assuming the free account sticks around)
    // TODO: Deprecate after 2020, remove those old vendors
    // return `https://img.gs/kzdlmwpqqk/${IMGOPTIM_OPTIONS}/${url}`;
  }
  // Image is _somehow_ using the wrong GCS bucket, so use imageoptim til we can work out how many of these there are and how to get rid of them. I suspect we had the filestack saving to the wrong bucket for a short period of time ¯\_(ツ)_/¯
  return `https://img.gs/kzdlmwpqqk/${IMGOPTIM_OPTIONS}/${url}`;
};
